<template>
  <div v-if="create" class="p-4">
    <div class="rounded shadow-md mx-auto bg-white w-full">
      <div class="p-4 space-y-4">
        <BaseFormGroup>
          <BaseFormLabel> Collection (optional) </BaseFormLabel>
          <BaseFormInput v-model="collectionName" placeholder="e.g. 'facebook creatives'" />
        </BaseFormGroup>
        <nav class="flex">
          <button
            class="flex-1 text-sm h-10 px-4 rounded focus:outline-none disabled:bg-transparent disabled:text-gray-600"
            :disabled="active"
            :class="[
              current === 'CreateMediaAsset' ? 'bg-blue-600 text-white' : 'bg-white text-gray-700',
            ]"
            @click="current = 'CreateMediaAsset'"
          >
            Local File
          </button>
          <button
            class="flex-1 text-sm h-10 px-4 rounded focus:outline-none disabled:bg-transparent disabled:text-gray-600"
            :disabled="active"
            :class="[
              current === 'CreateLinkAsset' ? 'bg-blue-600 text-white' : 'bg-white text-gray-700',
            ]"
            @click="current = 'CreateLinkAsset'"
          >
            Link
          </button>
          <button
            class="flex-1 text-sm h-10 px-4 rounded focus:outline-none disabled:bg-transparent disabled:text-gray-600"
            :disabled="active"
            :class="[
              current === 'CreateNoteAsset' ? 'bg-blue-600 text-white' : 'bg-white text-gray-700',
            ]"
            @click="current = 'CreateNoteAsset'"
          >
            Note
          </button>
        </nav>
      </div>
      <div class="p-4">
        <component
          :is="current"
          :project-id="project.uuid"
          :task-id="task.uuid"
          :on-data="processData"
          :on-media-asset-created="handleAssetCreated"
          :on-link-asset-created="handleAssetCreated"
          :on-note-asset-created="handleAssetCreated"
          :on-active="handleActive"
          @link-created="create = false"
        />
      </div>
      <div class="p-4">
        <BaseButton ghost class="w-full" @click="create = false"> Close </BaseButton>
      </div>
    </div>
  </div>

  <div v-else class="p-4">
    <div class="rounded shadow-md mx-auto bg-white w-full">
      <div class="p-4">
        <BaseButton type="button" primary class="w-full" @click="create = true">
          Add Asset
        </BaseButton>
      </div>
      <div class="p-4">
        <RelatedAssets :task-id="task.uuid" :project-id="project.uuid" />
      </div>
    </div>
  </div>
</template>

<script>
import CreateLinkAsset from '@/components/ProjectAssets/CreateLinkAsset.vue';
import CreateNoteAsset from '@/components/ProjectAssets/CreateNoteAsset.vue';
import CreateMediaAsset from './addAssets/CreateMediaAsset.vue';
import RelatedAssets from './task/RelatedAssets.vue';

export default {
  name: 'AddAssets',

  components: {
    CreateMediaAsset,
    CreateLinkAsset,
    CreateNoteAsset,
    RelatedAssets,
  },

  props: {
    task: {
      type: Object,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      create: false,
      active: false,
      current: 'CreateMediaAsset',
      collectionName: '',
    };
  },

  methods: {
    processData(data) {
      if (data instanceof FormData) {
        data.append('collection_name', this.collectionName);
        data.append('taskId', this.task.uuid);
      } else if (typeof data === 'object' && data !== null) {
        Object.assign(data, { taskId: this.task.uuid, collection_name: this.collectionName });
      }

      return data;
    },
    handleActive(active) {
      this.active = active;
    },
    async handleAssetReviewChange(reviewAssets) {
      this.active = true;

      try {
        await this.$store.dispatch({
          type: 'ui/projectTasks/update',
          projectId: this.project.uuid,
          taskId: this.task.uuid,
          formData: {
            reviewAssets,
          },
        });
      } catch (error) {
        //
      } finally {
        this.active = false;
      }
    },
    async handleAssetCreated(projectAssetId) {
      try {
        const projectAsset = this.$store.state.entities.projectAssets.byId[projectAssetId];
        await this.$store.commit({
          type: 'ui/taskAssets/addAssetIdToTask',
          taskId: this.task.uuid,
          assetId: projectAsset.assetId,
        });
      } catch (error) {
        //
      }
    },
  },
};
</script>
